import { render } from "./BaseButtonPrimary.vue?vue&type=template&id=6bb25ece&scoped=true"
import script from "./BaseButtonPrimary.vue?vue&type=script&lang=js"
export * from "./BaseButtonPrimary.vue?vue&type=script&lang=js"

import "./BaseButtonPrimary.vue?vue&type=style&index=0&id=6bb25ece&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb25ece"]])

export default __exports__